<div>
  <mat-card appearance="outlined">
    <mat-card-header>
      <div class="header-nombre-nuevo">
        <h2>Permisos</h2>
        <app-button-new matTooltip="Nuevo permiso" *appRoles="['Permisos.Crear']"
          (click)="openDialogCreate()"></app-button-new>
      </div>
    </mat-card-header>

    <mat-card-content>
      <div class="row align-items-center">
        <div class="col-auto">
          <button mat-stroked-button color="primary" *appRoles="['Permisos.Listar']" (click)="filtrar()">
            <mat-icon>filter_alt</mat-icon>
            Filtrar
          </button>
        </div>
        <div class="col-auto">
          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </mat-card-content>
    <mat-card-content>
      <br>
      <mat-divider></mat-divider>
      <br>
      <ngx-spinner [zIndex]="100" name="spPermisos" bdColor="rgba(255,255,255,0.8)" size="default"
        color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
      </ngx-spinner>

      <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->
        <!-- <app-button-action></app-button-action> -->
      </div>
      <mat-form-field appearance="outline" *ngIf="data" class="buscador-tabla">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
      </mat-form-field>
    </div>
    <!-- Fin Contenedor acciones tabla -->

      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" *ngIf="data" table matSort matSortStart="asc">
        <ng-container matColumnDef="descripcion">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            Descripción
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">
            <span>{{ element.descripcion }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="token">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            Token
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">
            <span>{{ element.token }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="casoUso">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            Caso Uso
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">
            <span>{{
              isFalsy(element.casoUso) ? "" : element.casoUso.descripcion
              }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="rol">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            Rol
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">
            <span>{{ isFalsy(element.rol) ? "" : element.rol.descripcion }}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="accion">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            Acción
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item  matTooltip="Ver" matTooltipPosition="right" *appRoles="['Permisos.Ver']"
                (click)="openDialogVer(element)">
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <button mat-menu-item matTooltip="Editar" matTooltipPosition="right" *appRoles="['Permisos.Modificar']"
                (click)="openDialogUpdate(element)">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item  matTooltip="Eliminar"  *appRoles="['Permisos.Eliminar']" matTooltipPosition="right"
                (click)="openDialogDelete(element)">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>
      <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>
      <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
